// extracted by mini-css-extract-plugin
export var DMSans = "Recruit-module--DMSans--j92K4";
export var companyImages = "Recruit-module--companyImages--LtLZZ";
export var paymentImage = "Recruit-module--paymentImage--iriwY";
export var root = "Recruit-module--root--Appze";
export var techList = "Recruit-module--techList--o4zd9";
export var techListHeading = "Recruit-module--techListHeading--cfwxz";
export var testimonialContainer = "Recruit-module--testimonialContainer--3P+PU";
export var testimonialOwner = "Recruit-module--testimonialOwner--eeLL2";